import React from 'react';
import './ProductPromotionFooter.scss';
import { PROMOTION_SEARCH_LABELS } from '../commonConstant';

const ProductPromotionFooter = ({ amount = 0, pv = 0, bv = 0, handleAddToCart }) => {
  return (
    <div className="product-promotion-footer-container">
      <div className="product-promotion-content">
        <div className="product-promotion-content_info">
          <span className="total-amount">฿ {amount}</span>
          <span className="pv-bv-details">PV {pv} / BV {bv}</span>
        </div>
        {amount == 0 ? (
          <span className="product-promotion-content_button-disabled" disabled>
            <img
              src="/images/promotion/icon_cart.svg"
              alt="Icon"
              className="product-button-icon"
            />
            <span className="product-button-text">{PROMOTION_SEARCH_LABELS.PRODUCT_FOOTER_BUTTON_TEXT}</span>
          </span>
        ) : (
          <span className="product-promotion-content_button-active" onClick={() => handleAddToCart()}>
            <img
              src="/images/promotion/icon_cart_active.svg"
              alt="Icon"
              className="product-button-icon"
            />
            <span className="product-button-text">{PROMOTION_SEARCH_LABELS.PRODUCT_FOOTER_BUTTON_TEXT}</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default ProductPromotionFooter;